var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraphic({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 986.161,
    height: 783.327,
    viewBox: "0 0 986.161 783.327",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_861",
    "data-name": "Path 861",
    d: "M61.061,239.846c11.888,62.194,1.081,127.9-29.72,181.479A232.339,232.339,0,0,0,0,537.74C0,673.291,116.988,783.327,261.535,783.327c52.415,0,101.048-14.352,141.845-39.23,41.878-25.516,90.241-35.4,137.252-26.791a453.384,453.384,0,0,0,84.3,7.655c199.394,0,361.232-125.345,361.232-280.033,0-126.3-108.072-233.148-256.672-267.913-43.769-10.206-82.945-36.36-113.476-72.719C564.138,41.782,467.953,0,357.99,0,192.369,0,58.359,94.726,58.359,211.46A142.032,142.032,0,0,0,61.061,239.846Z",
    fill: "rgba(0,0,0,0.03)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphic);
export default __webpack_public_path__ + "static/media/graphic.cc170bd2df0c465d8377a2c4b02e3a8e.svg";
export { ForwardRef as ReactComponent };